import React from 'react';
import Reveal from '../Reveal/Reveal';
import { IconPhone, IconMail, IconLocation } from '../Icons/Icons';
import '../../assets/css/contact.css';

function Contact() {
  return (
    <section className="section cta" id="contact">
      <div className="container">
        <div className="cta-card">
          <span className="cta-dots" aria-hidden="true" />
          <span className="cta-glow" aria-hidden="true" />

          <div className="cta-inner">
            <Reveal direction="up">
              <span className="section-label cta-eyebrow">Get In Touch</span>
              <h2 className="cta-title">Talk To Our Sustainability Consultants</h2>
              <p className="cta-lead">
                Whether you need certification support, regulatory reporting or carbon reporting
                guidance, our team is ready to help you maintain compliance and market access.
              </p>
              <div className="cta-actions">
                <a href="tel:01984624989" className="btn btn-primary">
                  <IconPhone width={17} height={17} /> Call 01984 624989
                </a>
                <a href="mailto:eviegarner@sustainabilityadvisors.co.uk" className="btn btn-outline-light">
                  <IconMail width={17} height={17} /> Email Us
                </a>
              </div>
              <p className="cta-address">
                <IconLocation width={16} height={16} /> Higher Ford, Wiveliscombe, Taunton, Somerset, TA4 2RL
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
